import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { nanoid } from 'nanoid';
export var MODIFICATION_ID = nanoid();

var hasBlockChildren = function hasBlockChildren(block) {
  return ['StickyBlock', 'MediaQueryBlock', 'PortalBlock', 'EntityBannerBlock'].includes(block.__typename);
};

var hasColumnChildren = function hasColumnChildren(block) {
  return block.__typename === 'ColumnBlock';
};

export var mapBlock = function mapBlock(f) {
  return function (block) {
    var newBlock = f(block);
    return hasBlockChildren(newBlock) ? _objectSpread(_objectSpread({}, newBlock), {}, {
      blocks: newBlock.blocks.map(mapBlock(f))
    }) : hasColumnChildren(newBlock) ? _objectSpread(_objectSpread({}, newBlock), {}, {
      columns: newBlock.columns.map(function (col) {
        return col.map(mapBlock(f));
      })
    }) : newBlock;
  };
};
export var mapAllBlocks = function mapAllBlocks(f) {
  return function (siteData) {
    return _objectSpread(_objectSpread({}, siteData), {}, {
      hash: "".concat(siteData.hash, "-").concat(MODIFICATION_ID),
      blocks: siteData.blocks.map(mapBlock(f))
    });
  };
};